/**
 * Persist outline proposal Accept/Reject so cards stay resolved after reload.
 */

export type OutlineProposalDecision = "accepted" | "rejected";

const storageKey = (bidId: string, proposalKey: string) =>
  `agents:outline-proposal-decision:${bidId}:${proposalKey}`;

/**
 * Read a stored decision for a proposal.
 * @param bidId - Bid id
 * @param proposalKey - Stable id (`proposal_id` or toolCallId)
 * @returns Stored decision, or null when unset
 */
export function readOutlineProposalDecision(
  bidId: string | null | undefined,
  proposalKey: string | null | undefined
): OutlineProposalDecision | null {
  if (!bidId || !proposalKey || typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(storageKey(bidId, proposalKey));
    if (value === "accepted" || value === "rejected") return value;
  } catch {
    // ignore quota / private mode
  }
  return null;
}

/**
 * Persist a decision for a proposal.
 * @param bidId - Bid id
 * @param proposalKey - Stable id (`proposal_id` or toolCallId)
 * @param decision - Accept or reject
 */
export function writeOutlineProposalDecision(
  bidId: string | null | undefined,
  proposalKey: string | null | undefined,
  decision: OutlineProposalDecision
): void {
  if (!bidId || !proposalKey || typeof window === "undefined") return;
  try {
    window.localStorage.setItem(storageKey(bidId, proposalKey), decision);
  } catch {
    // ignore quota / private mode
  }
}
